export const getCookie = (name: string): string | undefined => {
  const match = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'),
  );
  return match ? decodeURIComponent(match[1]) : undefined;
};

export type SetCookieOptions = {
  maxAgeSeconds?: number;
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: 'lax' | 'strict' | 'none';
};

export const setCookie = (name: string, value: string, options: SetCookieOptions = {}): void => {
  const { maxAgeSeconds, path = '/', domain, secure, sameSite = 'lax' } = options;
  let cookie = `${name}=${encodeURIComponent(value)}; path=${path}; samesite=${sameSite}`;
  if (maxAgeSeconds !== undefined) {
    cookie += `; max-age=${maxAgeSeconds}`;
  }

  if (domain) {
    cookie += `; domain=${domain}`;
  }

  if (secure) {
    cookie += '; secure';
  }

  document.cookie = cookie;
};
